import { keyMirror } from '~/util/helpers/keyMirror'
import { Config, Shipment } from './reducer'

export const ACTION = keyMirror(
  {
    UPDATE_DASHBOARD_CONFIG: null,
    UPDATE_DASHBOARD_REQUESTED: null,
    UPDATE_DASHBOARD_SUCCESS: null,
    UPDATE_DASHBOARD_FAILURE: null,
  },
  'dashboard'
)

export const updateDashboardConfig = (config: Config) => ({
  type: ACTION.UPDATE_DASHBOARD_CONFIG,
  payload: {
    config,
  },
})

export const updateDashboardRequested = (searchTerm: string = '') => ({
  type: ACTION.UPDATE_DASHBOARD_REQUESTED,
  payload: searchTerm,
})

export const updateDashboardSuccess = (shipments: Shipment[]) => ({
  type: ACTION.UPDATE_DASHBOARD_SUCCESS,
  payload: {
    shipments,
  },
})

export const updateDashboardFailure = (error: Error) => ({
  type: ACTION.UPDATE_DASHBOARD_FAILURE,
  error: true,
  payload: error,
})
